import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { IMAGE_MAP, getAssetUrl } from '../../const/imageRoutes';
import useConfig from '../../context/config.context';
const ImageContainerWidth = {
    small: '168px',
    medium: '216px',
    xsmall: '144px',
    xxsmall: '96px',
    icon: '24px'
};
const ImageContainerHeight = {
    small: '112px',
    medium: '144px',
    xsmall: '96px',
    xxsmall: '64px',
    icon: '24px'
};
const Image = styled.img `
  /* Center image inside the container */
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
const ImageContainer = styled.div `
  width: ${props => ImageContainerWidth[props.$size]};
  height: ${props => ImageContainerHeight[props.$size]};
  /* If image is in a flex container, width has no effect and flex-basis is used instead. */
  flex-basis: ${props => ImageContainerWidth[props.$size]};
  flex-shrink: 0;
  flex-grow: 0;
`;
const ModalImage = ({ alt, size, className, imageName }) => {
    const { config: { hosts: { assets: assetsHost } } } = useConfig();
    const { isLessThanTablet } = useWindowSize();
    const fileName = IMAGE_MAP[imageName];
    const devicePath = isLessThanTablet ? 'mobile/' : 'desktop/';
    const imageSource = `${getAssetUrl(assetsHost)}${devicePath}${fileName}`;
    const defaultImageSize = isLessThanTablet ? 'xsmall' : 'small';
    return (_jsx(ImageContainer, Object.assign({ className: className, "$size": size || defaultImageSize }, { children: _jsx(Image, { alt: alt, "aria-hidden": "true", "data-testid": "disputes-image", src: imageSource }) })));
};
export default ModalImage;
//# sourceMappingURL=index.js.map